const FOOD_OBJECT_IMAGES = {
  bird: 'img/food/bird.png',
  frog: 'img/food/frog.png',
  mouse: 'img/food/mouse.png',
  rabbit: 'img/food/rabbit.png',
  squirrel: 'img/food/squirrel.png'
};

const TRAP_OBJECT_IMAGES = {
  car: 'img/trap/car.png',
  dog: 'img/trap/dog.png',
  excavator: 'img/trap/Excavator.png',
  trap: 'img/trap/Trap.png'
};

const TIGER_IMAGES = {
  default: 'img/Leopard-cat-play.png',
  hitTrap: 'img/Leopard-cat-crash.png'
}

const GAME_OBJECT_IMAGES = Object.values(FOOD_OBJECT_IMAGES)
  .concat(Object.values(TRAP_OBJECT_IMAGES))
  .concat(Object.values(TIGER_IMAGES));

export {
  FOOD_OBJECT_IMAGES,
  TRAP_OBJECT_IMAGES,
  GAME_OBJECT_IMAGES,
  TIGER_IMAGES,
}
